import * as actions from './redux/actions';

import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import PropTypes from 'prop-types';
import { SvgHome } from '../common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';

export class PaymentRightSideBar extends Component {
	static propTypes = {
		pbServiceList: PropTypes.object,
		home: PropTypes.object,
		pbPaymentDetails: PropTypes.object.isRequired,
		actions: PropTypes.object.isRequired,

		walletMoneyAdded: PropTypes.func,
		virtualMoneyAmount: PropTypes.func,
		basicFare: PropTypes.func,
		calculateNetFare: PropTypes.func,
		calculateNetFareUSD: PropTypes.func,
		promoCode: PropTypes.string,
		promoCouponAmount: PropTypes.number,
		t: PropTypes.func,
		showUsd: PropTypes.bool,
		onPromoRemove: PropTypes.func,
		corporateDiscountState: PropTypes.object,
		instantDiscount: PropTypes.object,
	};

	countrieCodes = [];
	paymentGatewayList;
	idCardTypes = [];

	constructor(props) {
		super(props);
		this.state = {
			mobileError: null,
			emailError: null,
			confirmEmailError: null,
			selectedPaymentGateway: null,
			showBookingConfirmModal: false,
			wallet: false,
			walletMoney: 0,
			confirmTabSelected: 1,
			selectSeatsOnward: [],
			selectSeatsReturn: [],
			journeyTypeActive: 1,
		};
		// console.log('this.props payment options', this.props);
		this.isTSService =
			sessionStorage.getItem('isTSService') && sessionStorage.getItem('isTSService') === 'true'
				? true
				: false;
		this.isTSServiceRound =
			sessionStorage.getItem('isTSServiceRound') &&
				sessionStorage.getItem('isTSServiceRound') === 'true'
				? true
				: false;
	}

	componentWillMount() {
		if (
			this.props.pbServiceList.bookingDetailsOnward &&
			this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
		) {
			this.setState({
				selectSeatsOnward: this.seatTypesFrequeny(
					this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
				),
			});
		}
		if (
			this.props.pbServiceList.bookingDetailsReturn &&
			this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
		) {
			this.setState({
				selectSeatsReturn: this.seatTypesFrequeny(
					this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
				),
			});
		}
	}

	componentDidUpdate() {
		for (let c of this.props.home.metaData.country_codes) {
			this.countrieCodes.push({
				id: c,
				name: '+' + c,
			});
		}
		this.paymentGatewayList = CommonService.copyObject(
			this.props.home.metaData.payment_gate_way_list_v1,
		);
	}

	seatTypesFrequeny(arr) {
		var a = [],
			b = [],
			prev = {};

		arr.sort((a, b) => {
			if (a.fare > b.fare) return 1;
			if (b.fare > a.fare) return -1;

			return 0;
		});

		// for (var i = 0; i < arr.length; i++) {
		//   if (prev && arr[i].type !== prev.type) {
		//     a.push(arr[i]);
		//     b.push(1);
		//   } else {
		//     b[b.length - 1]++;
		//   }
		//   prev = arr[i];
		// }

		let arr2 = [];

		arr.map(val => {
			if (!val.is_pet_seat) {
				arr2.push({ is_pet_seat: false, ...val });
			} else {
				arr2.push(val);
			}
		});

		arr2.sort((a, b) => {
			if (a.is_pet_seat > b.is_pet_seat) return 1;
			if (b.is_pet_seat > a.is_pet_seat) return -1;

			return 0;
		});

		for (var i = 0; i < arr2.length; i++) {
			if (prev && arr2[i].type !== prev.type) {
				a.push(arr2[i]);
				b.push(1);
			} else {
				if (arr2[i].is_pet_seat !== prev.is_pet_seat) {
					a.push(arr2[i]);
					b.push(1);
				} else {
					b[b.length - 1]++;
				}
			}

			prev = arr2[i];
		}
		return [a, b];
	}

	renderSummaryDetailsCard = (service, date, source, dest, title) => {
		// console.log('Servuice --------------------', service);
		const { operator } = this.props;
		return (
			<div className="summary-details">
				<div className="op-name light-text font10">
					{service.route ? service.route.operator_service_name : ''}
				</div>
				{date ? (
					<span className="date font10">
						{DateService.getDayNameFromDate(date) +
							', ' +
							DateService.getDateFromDate(date) +
							' ' +
							DateService.getMonthNameFromDate(date) +
							', ' +
							DateService.getYearFromDate(date)}
					</span>
				) : null}
				<div className="location-details">
					<div className="city-name font11 bold-text">
						<img
							className="icon-source"
							// src={operator && operator.origin_icon ? operator.origin_icon : "/static/images/icons/home/icon_source.png"}
							src={getIcons('Origin', operator)}
							alt={this.props.t('TRANSLATIONS.ICON_SOURCE')}
						/>
						<span className="font11">{source ? source.label : ''}</span>
					</div>
					<div className="address light-text font10">
						{service.boardingStage
							? (service.boardingStage.name
								? service.boardingStage.name
								: service.boardingStage.landmark) + '. '
							: ''}
						{service.boardingStage ? (
							<span>{DateService.ampm(service.boardingStage.time)}</span>
						) : null}
					</div>
				</div>
				<div className="location-details">
					<div className="city-name font11 bold-text">
						<img
							className="icon-dest"
							// src={operator && operator.destination_icon ? operator.destination_icon : "/static/images/icons/home/icon_source2.png"}
							src={getIcons('Destination', operator)}
							alt=""
						// style={operator && operator.destination_icon ? { marginLeft: '-4px', width: '16px' } : null}
						/>
						<span className="font11">{dest ? dest.label : ''}</span>
					</div>
					<div className="address light-text font10">
						{service.droppingStage
							? (service.droppingStage.name
								? service.droppingStage.name
								: service.droppingStage.landmark) + '. '
							: ''}
						{service.boardingStage ? (
							<span>{DateService.ampm(service.droppingStage.time)}</span>
						) : null}
					</div>
				</div>
				{service.route ? (
					<div className="duration light-text font10">
						<img className="icon-source" src="/static/images/icons/icon_duration.svg" />
						<span>{this.props.t('PASSENGER_DETAILS.DURATION')} : </span> &nbsp;
						<span className="time">
							{service.route.duration}&nbsp;
							<span className="hours">{this.props.t('RESULTS_PAGE.HOURS')}</span>
						</span>
					</div>
				) : null}
			</div>
		);
	};

	renderDiscount = t => {
		let corporateName = this.props.corporateDiscountState && this.props.corporateDiscountState.name;
		let instantName = this.props.instantDiscount && this.props.instantDiscount.name;

		let corporateAmount =
			this.props.corporateDiscountState && this.props.corporateDiscountState.discount_amount;
		let instantAmount = this.props.instantDiscount && this.props.instantDiscount.discount_amount;

		let corporateType =
			this.props.corporateDiscountState && this.props.corporateDiscountState.type === 1
				? t('PASSENGER_DETAILS.DISCOUNT')
				: 'Cashback';
		let instantType =
			this.props.instantDiscount && this.props.instantDiscount.type === 1
				? t('PASSENGER_DETAILS.DISCOUNT')
				: 'Cashback';

		if (this.props.corporateDiscountState && this.props.instantDiscount) {
			return (
				<div className="discount-block fl ">
					<div className="discount-row flex-row">
						<div className="font10">
							<span>{instantAmount > corporateAmount ? instantType : corporateType}</span>
							<div>{instantAmount > corporateAmount ? instantName : corporateName}</div>
						</div>
						<div
							className="secondary-text font10 bold-text "
							tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
						>
							CLP{' '}
							{
								CommonService.currency(
									corporateAmount > instantAmount ? corporateAmount : instantAmount,
								).split(',')[0]
							}
						</div>
					</div>
				</div>
			);
		} else if (this.props.corporateDiscountState && !this.props.instantDiscount) {
			return (
				<div className="discount-block fl ">
					<div className="discount-row flex-row">
						<div className="font10">
							<span>{corporateType}</span>
							<div> {corporateName}</div>
						</div>
						<div
							className="secondary-text font10 bold-text "
							tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
						>
							CLP {CommonService.currency(corporateAmount).split(',')[0]}
						</div>
					</div>
				</div>
			);
		} else if (!this.props.corporateDiscountState && this.props.instantDiscount) {
			return (
				<div className="discount-block fl ">
					<div className="discount-row flex-row">
						<div className="font10">
							<span>{instantType}</span>
							<div> {instantName}</div>
						</div>
						<div
							className="secondary-text font10 bold-text "
							tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
						>
							CLP {CommonService.currency(instantAmount).split(',')[0]}
						</div>
					</div>
				</div>
			);
		} else return null;
	};

	render() {
		const { t } = this.props;
		let selectedServiceOnward =
			this.props.pbServiceList && this.props.pbServiceList.selectedServiceOnward
				? this.props.pbServiceList.selectedServiceOnward
				: {};
		let onwardPBDate = this.props.home ? this.props.home.onwardPBDate : null;
		let destCityOnward = this.props.home ? this.props.home.pbDestinationCity : null;
		let sourceCityOnward = this.props.home ? this.props.home.pbSourceCity : null;

		let selectedServiceReturn =
			this.props.pbServiceList && this.props.pbServiceList.selectedServiceReturn
				? this.props.pbServiceList.selectedServiceReturn
				: {};
		let returnPBDate = this.props.home ? this.props.home.returnPBDate : null;
		let sourceCityReturn = this.props.home ? this.props.home.pbDestinationCity : null;
		let destCityReturn = this.props.home ? this.props.home.pbSourceCity : null;

		return (
			<div className="pb-payment-details-payment-right-side-bar journey-summary-sidebar ">
				<div className="kupos-card">
					<div>
						<div className="summary-title font13">
							{t('PASSENGER_DETAILS.SUMMARY')}{' '}
							<span className="bold-text"> {t('PASSENGER_DETAILS.SUMMARY_BOLD')}</span>
						</div>

						<div className={'journey-date ' + (!returnPBDate ? 'flex-row' : '')}>
							<div className={'switch-buttons font10 ' + (returnPBDate ? 'rt' : '')}>
								<span
									className={'switch-item ' + (this.state.journeyTypeActive == 1 ? 'active' : '')}
									onClick={() => this.setState({ journeyTypeActive: 1 })}
									style={
										this.state.journeyTypeActive == 1 &&
											this.props.operator &&
											this.props.operator.color_codes &&
											this.props.operator.color_codes.secondary_color
											? { backgroundColor: this.props.operator.color_codes.secondary_color }
											: null
									}
								>
									{t('RESULTS_PAGE.GOING')}
								</span>
								{returnPBDate ? (
									<span
										className={'switch-item ' + (this.state.journeyTypeActive == 2 ? 'active' : '')}
										onClick={() => this.setState({ journeyTypeActive: 2 })}
										style={
											this.state.journeyTypeActive == 2 &&
												this.props.operator &&
												this.props.operator.color_codes &&
												this.props.operator.color_codes.secondary_color
												? { backgroundColor: this.props.operator.color_codes.secondary_color }
												: null
										}
									>
										{t('RESULTS_PAGE.RETURN')}
									</span>
								) : null}
							</div>
						</div>
						{this.state.journeyTypeActive == 1
							? this.renderSummaryDetailsCard(
								selectedServiceOnward,
								onwardPBDate,
								sourceCityOnward,
								destCityOnward,
								t('RESULTS_PAGE.GOING'),
							)
							: this.renderSummaryDetailsCard(
								selectedServiceReturn,
								returnPBDate,
								sourceCityReturn,
								destCityReturn,
								t('RESULTS_PAGE.RETURN'),
							)}
					</div>

					<div className="payment-details-sidebar">
						{/* <div className="payment-sidebar-title font13">
              {t('PASSENGER_DETAILS.PAYMENT_DETAILS.NORMAL')}{' '}
              <span className="bold">{t('PASSENGER_DETAILS.PAYMENT_DETAILS.BOLD')}</span>
            </div> */}
						<div className="payment-seats">
							{/* <div className="font12">{t('PASSENGER_DETAILS.SEATS')}</div> */}

							{this.props.pbServiceList &&
								this.state.selectSeatsOnward &&
								this.state.selectSeatsOnward[0]
								? this.state.selectSeatsOnward[0].map((val, key) => {
									// console.log('val is------  isTSService ', this.isTSService, val);
									return (
										<div key={key} className="payment-seat-row flex-row font10 ">
											<div>
												<span>{this.state.selectSeatsOnward[1][key]}</span>
												{' x '}
												{val.is_pet_seat
													? 'Asiento Mascota'
													: CommonService.capitalize(CommonService.getSeatName(val.type))}
												:
											</div>
											<div className="bold-text">
												CLP{' '}
												{
													// CommonService.currency(val.net_amount * selectSeatsOnward[1][key]).split(
													//   ',',
													// )[0]
													CommonService.currency(
														Number(this.isTSService ? val.o_fare : val.fare) *
														this.state.selectSeatsOnward[1][key],
													).split(',')[0]
												}
											</div>
										</div>
									);
								})
								: null}

							{this.props.pbServiceList &&
								this.state.selectSeatsReturn &&
								this.state.selectSeatsReturn[0]
								? this.state.selectSeatsReturn[0].map((val, key) => {
									return (
										<div key={key} className="payment-seat-row flex-row font10">
											<div>
												<span>{this.state.selectSeatsReturn[1][key]}</span>
												{' x '}
												{val.is_pet_seat
													? 'Asiento Mascota'
													: CommonService.capitalize(CommonService.getSeatName(val.type))}
												:
											</div>
											<div className="bold-text">
												CLP{' '}
												{
													CommonService.currency(
														Number(this.isTSServiceRound ? val.o_fare : val.fare) *
														this.state.selectSeatsReturn[1][key],
													).split(',')[0]
												}
											</div>
										</div>
									);
								})
								: null}
							{/* {this.props.pbServiceList &&
              this.state.selectSeatsOnward &&
              this.state.selectSeatsOnward[0]
                ? this.state.selectSeatsOnward[0].map((val, key) => {
                    return (
                      <div key={key} className="payment-seat-row flex-row font10 ">
                        <div>
                          <span>{this.state.selectSeatsOnward[1][key]}</span>
                          {' x '}
                          {CommonService.capitalize(CommonService.getSeatName(val.type))}:
                        </div>
                        <div className="bold-text">
                          CLP{' '}
                          {
                            CommonService.currency(
                              val.net_amount * this.state.selectSeatsOnward[1][key],
                            ).split(',')[0]
                          }
                        </div>
                      </div>
                    );
                  })
                : null}
              {this.props.pbServiceList &&
              this.state.selectSeatsReturn &&
              this.state.selectSeatsReturn[0]
                ? this.state.selectSeatsReturn[0].map((val, key) => {
                    return (
                      <div key={key} className="payment-seat-row flex-row font10">
                        <div>
                          <span>{this.state.selectSeatsReturn[1][key]}</span>
                          {' x '}
                          {CommonService.capitalize(CommonService.getSeatName(val.type))}:
                        </div>
                        <div className="bold-text">
                          CLP{' '}
                          {
                            CommonService.currency(
                              val.net_amount * this.state.selectSeatsReturn[1][key],
                            ).split(',')[0]
                          }
                        </div>
                      </div>
                    );
                  })
                : null} */}
						</div>

						{this.renderDiscount(t)}

						<div className="discount-block fl ">
							{!this.props.corporateDiscountState && !this.props.instantDiscount && (
								<div className="discount-row flex-row">
									<div className="font10">{t('PASSENGER_DETAILS.DISCOUNT')}</div>
									<div
										className="secondary-text font10 bold-text "
										tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
									>
										CLP{' '}
										{this.props.pbServiceList &&
											this.props.pbServiceList.bookingDetailsOnward &&
											this.props.pbServiceList.bookingDetailsOnward
											? CommonService.currency(
												this.props.pbServiceList.bookingDetailsOnward.discountAmount,
											).split(',')[0]
											: ''}
									</div>
								</div>
							)}
							<div className="discount-row flex-row">
								<div className="font10">{t('PASSENGER_DETAILS.PROMO_CODE')}</div>
								<div
									className="secondary-text font10 bold-text "
									style={{
										minWidth: 80,
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
									}}
								>
									CLP{' '}
									{
										CommonService.currency(
											this.props.promoCouponAmount ? this.props.promoCouponAmount : 0,
										).split(',')[0]
									}
								</div>
							</div>
							{this.props.promoCouponAmount ? (
								<div className="promocode font10">
									<div>{this.props.promoCode}</div>
									<span className="promo-remove" onClick={this.props.onPromoRemove}>
										<SvgHome name="close" />
									</span>
								</div>
							) : null}


							{this.props.virtual ? (
								<div className="subtotal-row flex-row">
									<div className="font10  "> {CommonService.getOperatorCredtiosLabel(this.props.operator)} {`(${this.props.virtualLimit}%)`}</div>
									<div className="secondary-text font10 bold-text ">
										CLP {CommonService.currency(+this.props.virtualMoneyAmount())}
									</div>
								</div>
							) : null}
						</div>

						{this.props.walletMoneyAdded() &&
							this.props.operator &&
							this.props.operator.is_pay_enabled ? (
							<div className="subtotal-row flex-row">
								<div className="font10">
									{CommonService.getOperatorPaymentLabel(this.props.operator)}
								</div>
								<div className="secondary-text font10 bold-text ">
									CLP {CommonService.currency(+this.props.walletMoneyAdded(this.props.basicFare()))}
								</div>
							</div>
						) : null}

						<div className="subtotal-block font10">
							{/* <div className="subtotal-row flex-row">
                <div className="primary-text">{t('PASSENGER_DETAILS.SUB_TOTAL')}</div>
                <div className="primary-text bold">
                  CLP{CommonService.currency((this.props.pbServiceList &&
                  this.props.pbServiceList.bookingDetailsOnward &&
                  this.props.pbServiceList.bookingDetailsOnward
                    ? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
                    : 0) +
                    (this.props.pbServiceList &&
                    this.props.pbServiceList.bookingDetailsReturn &&
                    this.props.pbServiceList.bookingDetailsReturn
                      ? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
                      : 0)).split(',')[0]}
                </div>
              </div> */}
							{this.props.showUsd ? (
								<div className="subtotal-row flex-row">
									<div className="primary-text">{t('PASSENGER_DETAILS.AMOUNT_IN_USD')}</div>
									<div className="primary-text bold-text ">
										USD{CommonService.currency(+this.props.calculateNetFareUSD()).split(',')[0]}
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
				<div
					className="total bold"
					style={
						this.props.operator &&
							this.props.operator.color_codes &&
							this.props.operator.color_codes.secondary_color
							? { backgroundColor: this.props.operator.color_codes.secondary_color }
							: null
					}
				>
					<div className="total-row flex-row font13">
						<div>Total</div>
						<div>CLP {CommonService.currency(+this.props.calculateNetFare()).split(',')[0]}</div>
					</div>
				</div>
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		pbServiceList: state.pbServiceList,
		home: state.home,
		pbPaymentDetails: state.pbPaymentDetails,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRightSideBar);



// WEBPACK FOOTER //
// ./src/features/pb-payment-details/PaymentRightSideBar.js